var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7444 1.44781C10.0849 1.78775 10.0855 2.34228 9.7444 2.68455L8.53509 3.89388L3.03608 9.39242L0 10L0.607568 6.96385L5.55556 2.01516L5.9678 2.42741L1.79239 6.6035L3.39643 8.20758L8.12285 3.48163L6.10599 1.46472L7.31529 0.255392C7.65697 -0.0851308 8.21149 -0.0851308 8.552 0.255392L9.7444 1.44781ZM2.98419 8.61982L1.38015 7.01574L1.14517 7.25073L0.744005 9.25598L2.74921 8.85481L2.98419 8.61982ZM6.89449 3.51755L3.28874 7.12338L2.8765 6.71114L6.48226 3.10531L6.89449 3.51755ZM9.41729 2.06589C9.41729 1.99125 9.3893 1.9172 9.33216 1.86006L8.13977 0.667636C8.02665 0.554519 7.84123 0.554519 7.72753 0.667636L6.93046 1.46473L8.5351 3.06939L9.33216 2.27231C9.3893 2.21516 9.41729 2.14053 9.41729 2.0659V2.06589Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.01715d4c453f5af7b372446d795058b9.svg";
export { ForwardRef as ReactComponent };